module.exports = __webpack_public_path__ + "img/logout.b6876cfc.svg";